export enum QATypes {
    SEARCH_SCORES = 'SEARCH_SCORES',
    SEARCH_SCORES_LOADING = 'SEARCH_SCORES_LOADING',
    SEARCH_SCORES_ERROR = 'SEARCH_SCORES_ERROR',
    SEARCH_CALIBRATIONS = 'SEARCH_CALIBRATIONS',
    SEARCH_CALIBRATIONS_LOADING = 'SEARCH_CALIBRATIONS_LOADING',
    SEARCH_CALIBRATIONS_ERROR = 'SEARCH_CALIBRATIONS_ERROR',
    SET_CURRENTLY_CALIBRATING = 'SET_CURRENTLY_CALIBRATING',
    GET_FULL_CALIBRATION = 'GET_FULL_CALIBRATION',
    CLEAR_CALIBRATION = 'CLEAR_CALIBRATION',
    CALIBRATION_BUSY = 'CALIBRATION_BUSY',
    GET_SCORE = 'GET_SCORE',
    GET_SCORE_LOADING = 'GET_SCORE_LOADING',
    CLEAR_SCORE = 'CLEAR_SCORE',
    UPDATE_SCORE = 'UPDATE_SCORE',
    UPDATE_SCORE_LOADING = 'UPDATE_SCORE_LOADING',
    SCORE_CALCULATE = 'SCORE_CALCULATE',
    NEW_SCORE = 'NEW_SCORE',
    CREATING_SCORE = 'CREATING_SCORE',
    DELETE_SCORE = 'DELETE_SCORE', // do the actual delete from store
    DELETE_SCORE_LOADING = 'DELETE_SCORE_LOADING', // delete req in progress
    DELETING_SCORE = 'DELETING_SCORE', // confirm delete
    SET_SCORE_SEARCH_PARAMS = 'SET_SCORE_SEARCH_PARAMS',
    SET_SHOW_NEW_SCORE = 'SET_SHOW_NEW_SCORE',
    START_CALIBRATION = 'START_CALIBRATION',
    CHANGE_CALIBRATION_STATUS = 'CHANGE_CALIBRATION_STATUS',
    GET_QA_TEMPLATES = 'GET_QA_TEMPLATES',
    CREATE_QA_TEMPLATE = 'CREATE_QA_TEMPLATE',
    EDIT_QA_TEMPLATE = 'EDIT_QA_TEMPLATE',
    DELETE_QA_TEMPLATE = 'DELETE_QA_TEMPLATE',
    START_NEW_CALIBRATION = 'START_NEW_CALIBRATION',
    MY_SCORES_ERROR = 'MY_SCORES_ERROR',
    MY_SCORES_LOADING = 'MY_SCORES_LOADING',
    GET_MY_SCORES = 'GET_MY_SCORES',
    GET_EVALUATION_CONFIG_LOADING = 'GET_EVALUATION_CONFIG_LOADING',
    GET_EVALUATION_CONFIG = 'GET_EVALUATION_CONFIG',
    GET_EVALUATION_CONFIG_ERROR = 'GET_EVALUATION_CONFIG_ERROR',
    GET_UNREAD_SCORES_COUNT = 'GET_UNREAD_SCORES_COUNT',
    SET_UNREAD_SCORES_COUNT = 'SET_UNREAD_SCORES_COUNT',
}